'use client';

import { Stack } from '@mui/material';
import Image from 'next/image';
import { useEffect } from 'react';

import { backgrounds } from '@/assets/materials';
import { CTASection } from '@/components/CTASection';
import { CoreServicesSection } from '@/components/CoreServicesSection';
import { FeatureSections } from '@/components/FeatureSections';
import { HeroSection } from '@/components/HeroSection';
import { PricingSection } from '@/components/PricingSection';
import { TrustedSection } from '@/components/TrustedSection';
import { useGA } from '@/hooks/useGA';

export default function Page() {
  const { trackGAEvent } = useGA();

  useEffect(() => {
    trackGAEvent({
      action: 'page_view',
      category: 'orbit_landing',
      label: 'Home page view',
    });
  }, [trackGAEvent]);
  return (
    <Stack width={'100%'} height={'100%'}>
      <HeroSection />
      <div className='bg-[#060912]'>
        <div className='relative'>
          <div className='absolute top-0 left-0 right-0 bottom-0'>
            <div className='relative w-full h-full'>
              <Image fill alt={'alt'} src={backgrounds.vector} className={'object-contain'} />
            </div>
          </div>
          <CoreServicesSection />
          <FeatureSections />
        </div>
        <PricingSection />
        <TrustedSection />
        <div className='relative'>
          <div className='absolute top-0 left-0 right-0 bottom-0'>
            <div className='relative w-full h-full'>
              <Image fill alt={'alt'} src={backgrounds.vector_2} className={'object-cover'} />
            </div>
          </div>

          <CTASection />
          {/* <ContactFormSection /> */}
        </div>
      </div>
    </Stack>
  );
}
